import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import { useTranslation } from 'react-i18next';

import { CHILD_READING_BOOKS } from '../../../../services/readingBook/graphql';
import ReadingBooksContent from './readingBooksContent';

const ReadingBooks = ({ id }) => {
    const { t } = useTranslation();
       const {
           data: readingBooks,
           error,
           loading,
       } = useQuery(CHILD_READING_BOOKS, {
           variables: {
               childId: id,
           },
            fetchPolicy: 'network-only'
       });
   

    return (
        <>
        {loading && <p>{t('loading')}</p>}
        {error && <p>{t('something_happened')}</p>}
        {readingBooks && <ReadingBooksContent id={id} student={readingBooks.child.student} />}
        </>
    )
}

export default ReadingBooks;
